module.exports = __webpack_public_path__ + "fonts/la-regular-400.7711147.eot";